import Reveal from "@/components/base/Reveal";
import { benefits } from "@/mocks/navigation";
import { useSiteText } from "@/lib/siteContent";

export default function Benefits() {
  return (
    <section className="w-full border-b border-background-200 bg-background-100" aria-label="Nossos benefícios">
      <div className="px-4 py-12 md:px-8 md:py-14">
        <div className="mx-auto grid max-w-7xl grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4 lg:gap-10">
          {benefits.map((benefit, index) => (
            <Reveal key={benefit.id} delay={index * 90}>
              <BenefitItem index={index} icon={benefit.icon} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

function BenefitItem({ index, icon }: { index: number; icon: string }) {
  const title = useSiteText(`benefits.${index}.title`, "");
  const text = useSiteText(`benefits.${index}.text`, "");
  return (
    <div className="flex items-start gap-4">
      <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700">
        <i className={`${icon} text-xl`} />
      </span>
      <div>
        <h3 className="font-heading text-xl text-foreground-900">{title}</h3>
        <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{text}</p>
      </div>
    </div>
  );
}